module.exports = __webpack_public_path__ + "img/xf.e15d4e94.png";